import { Menu, OpenMenu } from 'autogen/translation-keys/trans-website-shared';
import { Button } from 'components/Button';
import useSmartviewManager from 'components/generic/smartview/shared/hooks/useSmartviewManager';
import { smartviewInstanceAtom } from 'components/generic/smartview/shared/recoil/atoms';
import Icon from 'components/Icon';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import { useRecoilValue } from 'recoil';
import React, { Suspense, useEffect, useState } from 'react';

const StyledText = styled.span`
    display: none;
    margin-left: 8px;

    ${breakpoint.up(sizes.sm)} {
        display: flex;
    }
`;

const SIDE_MENU_ID = 'side-menu';
const RootMenu = React.lazy(() => import('./components/Menu/RootMenu'));

export default function SideMenuOpener() {
    const { open } = useSmartviewManager(SIDE_MENU_ID);
    const { t } = useTranslation();
    const { isOpen } = useRecoilValue(smartviewInstanceAtom(SIDE_MENU_ID));
    const [hasOpened, setHasOpened] = useState(false);

    // Prefetch RootMenu chunk after page load
    useEffect(() => {
        import('./components/Menu/RootMenu');
    }, []);

    // Set true when the menu is opened for the first time
    useEffect(() => {
        if (isOpen && !hasOpened) {
            setHasOpened(true);
        }
    }, [isOpen]);

    return (
        <>
            <Button aria-label={t(OpenMenu)} onClick={open} variant="secondary">
                <Icon type="Menu" size={16} />
                <StyledText>{t(Menu)}</StyledText>
            </Button>

            {hasOpened && (
                <Suspense fallback={null}>
                    {/* SideMenu gets mounted using React portal internally */}
                    <RootMenu />
                </Suspense>
            )}
        </>
    );
}
